<template>
    <section>
        <slot name="title" v-if="items.length > 0"></slot>
        <table class="c-marketing-products" v-if="items.length > 0">
            <tr v-for="item in items" :key="item.id">
                <td v-if="item.image" class="c-marketing-product__image-col">
                    <img class="c-marketing-product__image" :src="item.image.src" :alt="item.image.alt">
                </td>
                <td>
                    {{ item.id }}
                </td>
                <td class="c-marketing-product__name-col">
                    <strong>{{ item.name }}</strong>
                </td>
                <td>
                    {{ item.price | currency(customerCurrencySymbol) }}
                </td>
                <td>
                    <v-input v-model.number="item.amount" name="amount" type="number" size="5" custom-class="u-flex--reverse-row">
                        <slot slot="label">stuks</slot>
                    </v-input>
                </td>
                <td>
                    <v-input v-model.number="item.discount" name="discount" type="number" size="5" custom-class="u-flex--reverse-row">
                        <slot slot="label">% korting</slot>
                    </v-input>
                </td>
            </tr>
        </table>

        <div class="u-font-large u-padding u-text-align-center" v-else>
            Er is nog geen marketingmateriaal beschikbaar.
        </div>
    </section>
</template>

<script>
    import Vue from 'vue'
    import VInput from '@/components/form/Input'

    export default {
        props: {
            items: Array,
        },
        components: {
            VInput,
        },
        data() {
            return {}
        },
        methods: {},
        computed: {
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        }
    }
</script>

<style lang="scss" scoped="">

    @import "~@/assets/scss/private";

    .c-marketing-products {
        width: 100%;
        border-collapse: collapse;
        $gutter: em($global-spacing-unit);

        tr {
            &:not(:last-child) {
                td {
                    border-bottom: 2px solid white;
                }
            }
        }

        td {
            white-space: nowrap;
            padding: em($global-spacing-unit-tiny);
            &:not(:last-child) {
                padding-right: $gutter;
            }
            background-color: palette(color-neutral, x-light);
        }
    }

    .c-marketing-product__name-col {
        width: 100%;
        white-space: normal;
    }

    $image-size: 90px;
    .c-marketing-product__image-col {
        min-width: $image-size;
        max-width: $image-size;
        text-align: center;
    }

    .c-marketing-product__image {
        max-width: 100%;
        max-height: $image-size;
    }


</style>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-marketing-products {
        .c-input {
            min-width: em(70px);
            max-width: em(70px);
        }
        .c-label {
            margin-left: em($global-spacing-unit-small);
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/product/marketing/MarketingProducts.vue